/**
 * @desc 根据sku编号获取sku简要信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuBriefDetailDto>;
export function request(skuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/geSkuBriefInfo/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
